export default "__VITE_ASSET__BvtiRkVq__"